import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { VisitorWorkflowType } from 'types/visitorWorkflowTypes';
import { useTranslation } from 'react-i18next';
import { VideoDeviceType } from 'types/videoDeviceTypes';

interface VideoFormProps {
  workflowTypes: VisitorWorkflowType[];
  videoDevices: VideoDeviceType[];
}

const VideoForm: React.FC<VideoFormProps> = ({ workflowTypes, videoDevices }) => {
  const { t } = useTranslation();

  return (
    <>
      {workflowTypes.map((type) => {
        const fieldMap: Record<number, string> = {
          1: 'signInDeviceId',
          2: 'signOutDeviceId',
          3: 'kioskInDeviceId',
          4: 'kioskOutDeviceId',
        };

        const name = fieldMap[type.id];
        if (!name || !type.languageCode) return null;

        const options = videoDevices.map((device) => ({
          label: device.name,
          value: device.guId,
        }));

        return (
          <OpForm.Select
            key={type.id}
            name={name}
            label={t(type.languageCode, type.name ?? '')}
            placeholder={t('location.video.selectDevice')}
            options={options}
            mode='multiple'
          />
        );
      })}
    </>
  );
};

export default VideoForm;
